<template>
  <div class="content">
    <form>
      <kirim-form :datas="dataall"></kirim-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.prixod.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { KirimForm, Kontragent, Firma, Sklad, Paytype } from "@/pages";
  export default {
    components: {
      KirimForm,
      Kontragent,
      Firma,
      Sklad,
      Paytype
    },
    created: function () {
      let self = this;
      axios
        .get("api/v1/prixod/last-number")
        .then(function (response) {
          self.dataall.number = response.data.number;
          self.$store.state.saved = null;
        });
      axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function (response) {
          self.dataall.dollar_rate = response.data.rate;
          self.$store.state.saved = null;
        });
    },
    watch: {
      dataall: {
        deep: true,
        handler(val, oldVal) {
          this.$store.state.saved += 1;
        }
      }
    },
    beforeMount() {
      // window.addEventListener("beforeunload", this.preventNav);
    },
    beforeRouteLeave(to, from, next) {
      this.$root.$refs.prixod.SaveSettings();
      if (this.$store.state.saved < 2) {
        this.$store.state.saved = null;
        localStorage.removeItem("prostatka");
        next();
        this.$store.state.selected_index = null;
      } else {
        this.$bvModal.show("modal-close");
      }
    },
    data() {
      return {
        dataall: {
          number: 0,
          dollar_rate: 0,
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          created_at: new Date()
            .valueOf()
            .toString()
            .slice(0, 10),
          updated_at: new Date()
            .valueOf()
            .toString()
            .slice(0, 10),
          kontragent_id: 0,
          debit_summa: 0,
          user_id: parseInt(localStorage.getItem("user_id")),
          pay_type_id: 1,
          rasxod_summa: 0,
          skidka_summa: 0,
          prixod_summa: 0,
          summa: 0,
          comment: "",
          count_all: 0,
          // Qarz qaysi valyutada yoziladi (Dollar pay_type tanlansa Form.vue'da true bo'lib o'rnatiladi)
          debt_in_dollar: false,
          // Tannarx valyutasi — to'lov turidan MUSTAQIL (1=so'm, 2=dollar).
          // Default so'm: hujjatlarning aksariyati so'mda kiritiladi va noto'g'ri
          // dollar belgisi tannarxni ×kurs shishirib yuboradi.
          cost_currency: 1,
          prixod_table: [
            {
              product_id: 0,
              current_balance: 0,
              count: 0,
              debit_price: 0,
              debit_summa: 0,
              kontragent_price: 0,
              kontragent_summa: 0,
              chakana_percent: 0.0,
              optom_percent: 0,
              chakana_price: 0,
              chakana_dollar_price: 0,
              optom_price: 0,
              optom_dollar_price: 0,
              chakana_summa: 0,
              optom_summa: 0,
              shtrix_kod: "",
              pack_count: 0,
              pack_price: 0,
              pack_norma: 0
            }
          ]
        }
      };
    },
    methods: {
      Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Кирим" });
      }
      //   preventNav(event) {
      //     event.preventDefault();
      //     event.returnValue = "";
      //   }
    },
  };
</script>